export const EditFor = Object.freeze({
    FOR_EMPLOYEE: 'FOR_EMPLOYEE',
    FOR_CASH_REGISTER: 'FOR_CASH_REGISTER'
})